(function () {
  var CHANGE_LABEL = true; // set false to keep the theme's button wording

  function wire(form) {
    if (form.dataset.preorderWired === 'true') return;          // idempotent
    var dataEl = form.querySelector('[data-preorder-data]');
    if (!dataEl) return;                                        // not a preorder form
    form.dataset.preorderWired = 'true';

    var data = {};
    try { data = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }

    function sync() {
      var idEl = form.querySelector('[name="id"]');
      if (!idEl) return;
      var entry = data[String(idEl.value)];
      var input = form.querySelector('[data-preorder-selling-plan]');
      if (input) {
        if (entry && entry.mode === 'preorder') { input.value = entry.sellingPlanId; input.disabled = false; }
        else { input.disabled = true; input.value = ''; }       // disabled => skipped by serialize() + native submit
      }
      if (CHANGE_LABEL) {
        var textEl = form.querySelector('[data-add-to-cart-text]');
        if (textEl) {
          if (entry && entry.label && entry.mode !== 'standard') {
            if (!textEl.dataset.preorderOrig) textEl.dataset.preorderOrig = textEl.textContent.trim();
            textEl.textContent = entry.label;
          } else if (textEl.dataset.preorderOrig) {
            textEl.textContent = textEl.dataset.preorderOrig;
          }
        }
      }
    }

    sync();
    form.addEventListener('change', sync);  // theme fires a (non-bubbling) change on the form per variant switch
  }

  function wireAll(root) {
    (root || document).querySelectorAll('[data-product-form]').forEach(wire);
  }

  function init() {
    wireAll(document);  // main PDP + featured product (server-rendered)

    // Quick View injects product HTML via innerHTML, so its own <script> can't run.
    // Watch the modal content and wire any product form that gets injected.
    var qv = document.querySelector('.quick-view-modal__content');
    if (qv && 'MutationObserver' in window) {
      new MutationObserver(function () { wireAll(qv); }).observe(qv, { childList: true, subtree: true });
    }

    // Bonus hooks if the theme has custom events enabled
    document.addEventListener('quickview:loaded', function () { wireAll(document); });
    document.addEventListener('product:variant-change', function () { wireAll(document); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();